<template>
  <div class="main-app">
    <KIWForm />
  </div>
</template>

<script src="./KIWFormApp.js" lang="js"></script>
